import type { CdnPath } from "./cdnPath";

export type CdnRenderFit = "contain" | "cover" | "fill" | "inside";
export type CdnRenderFormat = "auto" | "avif" | "jpeg" | "png" | "webp";
export type CdnRenderPosition =
  | "attention"
  | "bottom"
  | "bottom-left"
  | "bottom-right"
  | "center"
  | "entropy"
  | "left"
  | "right"
  | "top"
  | "top-left"
  | "top-right";

export interface CdnRenderOptions {
  fit?: CdnRenderFit;
  format?: CdnRenderFormat;
  height?: number;
  position?: CdnRenderPosition;
  width?: number;
}

export function buildCdnRenderPath(path: string, options: CdnRenderOptions): CdnPath {
  const width = options.width ?? "auto";
  const height = options.height ?? "auto";
  if (width === "auto" && height === "auto") return path as CdnPath;
  const fit = options.fit ?? "inside";
  const position = options.position ?? "center";
  const format = options.format ?? "auto";
  return `${path}/render/${width}x${height}/${fit}/${position}/${format}` as CdnPath;
}
